import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { headerStyles } from "@tKgpco/Overrides/Widgets/AccountSettings/AccountSettingsHeader";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";

import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(orderDetailsButtonSetStyles, {
    reorderButton: buttonStyle.continueButton,
    rmaButton: buttonStyle.cancelButton,
    printButton: buttonStyle.cancelButton,
    overflowMenu: headerStyles.overflowMenu,
});
